import React from 'react';
import { Flex } from '../../primitives';
import { FormControlSlotProps } from './defines';

export const FormControlSlot: React.FC<FormControlSlotProps> = (props) => {
  const { children, ...rest } = props;
  return <Flex {...rest}>{children}</Flex>;
};
